module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-lineup-kyoto-4-b65471ebe6647fa305993f2287724927.jpg";